import { useEffect, useState } from "react";
import { Form, Input, Select, Button, Checkbox, Row, Col, Tag } from "antd";
import TextArea from "antd/es/input/TextArea";
import { resolveInputType } from "../utils/resolveInputType";
import { useDispatch, useSelector } from "react-redux";
import { getLeadRatingList } from "../actionCreator/leadListingActionCreater";

const DynamicForm = ({
  payload,
  onSubmit,
  submitLabel = "Submit",
  initialValues,
  title,
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [rating, setRating] = useState();
  const {
    template = {},
    requiredFields = {},
    fieldMeta = {},
    error = {},
    type,
  } = payload;

  useEffect(() => {
    dispatch(getLeadRatingList());
  }, [dispatch]);

  const leadRatingListing = useSelector(
    (state) => state.leadListingReducer.leadRatingList,
  );

  useEffect(() => {
    form.setFieldsValue(template);
  }, [template, form]);

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
      setRating(initialValues?.leadRating);
    }
  }, [form, initialValues]);

  const handleFinish = (values) => {
    onSubmit(values);
  };

  const PRIORITY_FIELDS = ["firstname", "lastname"];

  const orderedFields = [
    ...PRIORITY_FIELDS.filter((f) => requiredFields[f]),
    ...Object.keys(requiredFields).filter(
      (key) => !PRIORITY_FIELDS.includes(key),
    ),
  ];

  return (
    <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-mt-8">
      <Form
        form={form}
        layout="vertical"
        className="tw-w-[60%] tw-border tw-border-solid tw-border-[#CDD2DF] tw-rounded-[10px]"
        onFinish={handleFinish}
      >
        {title && (
          <div className="tw-text-sm tw-font-bold tw-p-4 tw-border-b tw-border-solid tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-[#CDD2DF]">
            {title}
          </div>
        )}
        <div className="tw-px-5 tw-py-3">
          {!!error && (
            <div className="text-error mb10 text-center">{error?.title}</div>
          )}
          <Row gutter={[24, 0]}>
            {orderedFields?.map((field) => {
              const meta = fieldMeta[field] || {};
              const inputType = resolveInputType(
                field,
                requiredFields[field],
                meta,
              );

              if (inputType === "hidden") {
                return (
                  <Form.Item key={field} name={field} hidden>
                    <Input />
                  </Form.Item>
                );
              }

              return (
                <Col md={12}>
                  <Form.Item
                    key={field}
                    name={field}
                    label={
                      <label className="fw-medium">
                        {field.replace(/([A-Z])/g, " $1")}
                      </label>
                    }
                    rules={
                      inputType === "email"
                        ? [
                            {
                              type: "email",
                              message: "Please enter valid E-mail!",
                            },
                            { required: true, message: "Required" },
                          ]
                        : [{ required: true, message: "Required" }]
                    }
                  >
                    {field === "leadRating" ? (
                      <div className="tw-flex tw-items-center tw-flex-wrap">
                        {leadRatingListing?.map((item, i) => (
                          <Tag
                            key={i}
                            className={`${rating === item?.ratingText ? "tw-bg-theme tw-border-theme tw-text-white" : "tw-bg-white tw-border-[#CDD2DF]"} tw-cursor-pointer`}
                            onClick={() => {
                              form.setFieldsValue({
                                leadRating: item?.ratingText,
                              });
                              setRating(item?.ratingText);
                            }}
                          >
                            {item?.ratingText}
                          </Tag>
                        ))}
                      </div>
                    ) : (
                      <>
                        {inputType === "textarea" && <TextArea rows={4} />}
                        {inputType === "select" && (
                          <Select placeholder="Select">
                            {meta.options?.map((opt) => (
                              <Select.Option key={opt} value={opt}>
                                {opt}
                              </Select.Option>
                            ))}
                          </Select>
                        )}

                        {inputType === "checkbox" && <Checkbox />}

                        {["text", "email", "number", "tel"].includes(
                          inputType,
                        ) && (
                          <Input
                            type={inputType === "email" ? "text" : inputType}
                            className="common-input"
                          />
                        )}
                      </>
                    )}
                  </Form.Item>
                </Col>
              );
            })}
          </Row>
        </div>
        <Form.Item className="tw-pt-5 tw-px-5 tw-flex tw-justify-end tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-t tw-border tw-border-solid tw-border-[#CDD2DF]">
          <Button type="primary" htmlType="submit" className="theme-btn">
            {type === "CLIENT_LEAD.CREATE.FORM" ? "Create Lead" : submitLabel}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default DynamicForm;
